import { Vue, Component } from 'vue-property-decorator';
import { Form } from 'element-ui';
import { State, Mutation } from 'vuex-class';
import { ILOGPRE } from '@/types/base.d';
import api from '@/api/org';

@Component
export default class formMixin extends Vue {
  @State(state => state.org.curComp) curComp!: string;

  @Mutation('org/SET_ORG_BTN_COMPENT') setCurComp!: Function;

  @Mutation('org/SET_ORG_COMPENT_REFRESH') handleRerfesh!: Function;

  public log: ILOGPRE = {
    name: '机构管理 - 合同 - 模态框 -',
    component: 'org/manage/components/bModal',
  };

  public form: any = {
    orgPid: '',
    statusTag: 1,
    paperPid: '',
  };

  private loading: boolean = false;

  public $refs!: {
    form: Form,
  };

  private rules: any = {
    paperPid: [
      { required: true, message: '试卷不能为空！', trigger: 'blur' }
    ]
  };

  private examOptions: any = []

  // 查询试卷列表
  getExamList() {
    api.getExamList(this.form.orgPid).then((res: any) => {
      console.log(res);
      this.examOptions = res;
    })
  }

  /* eslint-disable class-methods-use-this */
  reset(close: boolean, refrsh: boolean) {}

  /**
   * @author liangyongmou
   * @desc 重置表单
   * @param 空
   */
  resetForm() {
    this.$refs.form.resetFields();
  }

  /**
   * @author Terry
   * @description 提交Form 完成后执行此方法
   */
  submitFinish() {
    this.reset(true, true);
    this.loading = false;
    if (this.curComp !== 'Exam') this.setCurComp('Exam');
    else this.handleRerfesh(true);
  }

  /**
   * @author liangyongmou
   * @desc 添加/编辑合同
   * @param { string } title 标题
   */
  submit(title: string) {
    this.loading = true;
    this.$refs.form.validate((valid: boolean) => {
      if (valid) {
        this.$log({
          title: `${this.log.name}提交`,
          component: this.log.component,
        });
        api.addExam(this.form).then(() => {
          this.submitFinish();
          /* eslint-disable no-return-assign */
        }).catch(() => (this.loading = false));
      } else this.loading = false;
    });
  }
}
